export default "__VITE_PUBLIC_ASSET__34a05037__"